import { render, staticRenderFns } from "./MetaDataUpload.vue?vue&type=template&id=d21d57f8&scoped=true&"
import script from "./MetaDataUpload.vue?vue&type=script&lang=js&"
export * from "./MetaDataUpload.vue?vue&type=script&lang=js&"
import style0 from "./MetaDataUpload.vue?vue&type=style&index=0&id=d21d57f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21d57f8",
  null
  
)

export default component.exports